// layoutUtils.js
import * as NodeUtils from '../../Utils/NodeUtils';
import { updateVerticalNodePositions } from './nodeVerticalPositionUtils';

const CANVAS_MIN_WIDTH = 1960;
const CANVAS_MIN_HEIGHT = 960;
const CANVAS_MARGIN_RIGHT = 160;
const CANVAS_MARGIN_BOTTOM = 20;
const CANVAS_MARGIN_LEFT = 120;
const DEFAULT_WIDTH = 50000;
const GRAPH_MIN_WIDTH = 500;

/**
 * Calcule les dimensions globales du graphe
 * @param {Object} treeRoot - Nœud racine de l'arbre
 * @param {number} zoom - Niveau de zoom actuel
 * @returns {Object} Dimensions {height, width} du graphe
 */
export const computeGraphSize = (treeNodes, zoom) => {
  let height =
    Math.max(0, ...treeNodes.map((node) => node.y + node.ySize)) +
    GRAPH_MIN_WIDTH;
  let width = DEFAULT_WIDTH;

  // Ajustement en fonction du scroll et du zoom
  height = Math.max(height, document.documentElement.scrollHeight) / zoom;
  width = Math.max(width, document.documentElement.scrollWidth) / zoom;
  return { height, width };
};

/**
 * Configure la disposition des nœuds
 * @param {Array} nodes - Nœuds à disposer
 * @param {Object} mapNodesSize - Map des tailles des nœuds
 * @param {Array} collapsedNodes - Nœuds repliés
 * @param {Array} arraySortByWithType - Configuration de tri
 * @returns {Object} Racine de l'arbre configuré
 */
export const setupNodesLayout = (
  nodes,
  mapNodesSize,
  collapsedNodes,
  arraySortByWithType,
  scrollTop,
  autoVertPos,
  displayMode
) => {
  if (!nodes || nodes.length === 0) return [];
  // Retirer les nœuds repliés
  nodes = NodeUtils.removeCollapsed(nodes, collapsedNodes);

  // Trier les nœuds
  nodes = NodeUtils.sortArray(nodes, 0, arraySortByWithType);

  // Créer la racine
  const rootNode = {
    key: 'root',
    children: nodes,
    nbChild: nodes.length,
    nbRandom: 0,
  };
  return updateVerticalNodePositions(
    rootNode,
    scrollTop,
    mapNodesSize,
    autoVertPos,
    displayMode
  );
};

/**
 * Configure le canvas SVG
 * @param {Object} dimensions - Dimensions du graphe
 * @returns {Object} Configuration du canvas
 */
export const configureSVGCanvas = ({ height, width }) => {
  let vOffset = height / 2;
  vOffset = 0;
  const margin = {
    top: vOffset,
    right: CANVAS_MARGIN_RIGHT,
    bottom: CANVAS_MARGIN_BOTTOM,
    left: CANVAS_MARGIN_LEFT,
  };

  const canvasWidth = Math.max(
    1 * (CANVAS_MIN_WIDTH - margin.right - margin.left),
    width
  );
  const canvasHeight = Math.max(
    1 * (CANVAS_MIN_HEIGHT - margin.top - margin.bottom),
    height
  );

  return {
    width: canvasWidth + margin.right + margin.left,
    height: canvasHeight + margin.top + margin.bottom,
    margin,
  };
};
